/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Skeleton } from './Skeleton';
export var BadgeSkeleton = function (_a) {
    var className = _a.className;
    return (jsx(Skeleton, { className: className, sx: { width: 40, height: '1.5em', borderRadius: '0.75em' } }));
};
//# sourceMappingURL=BadgeSkeleton.js.map